export const serviceHeaders = {
    CODE : 'Code',
    SERVICES : 'Services ',
    CATEGORY : 'Category',
    SERVICE_PRICE : 'Service Price ',
    GST : 'GST %',
    TDS : 'TDS %',
}